import type { CompareOrientation } from '../types';

const COMPARE_ORIENTATION_KEY = 'analyzePanel.compareOrientation';
const DEFAULT_ORIENTATION: CompareOrientation = 'vertical';

const isCompareOrientation = (value: string | null): value is CompareOrientation =>
  value === 'vertical' || value === 'horizontal' || value === 'overlaid';

export const readCompareOrientation = (): CompareOrientation => {
  try {
    const value = localStorage.getItem(COMPARE_ORIENTATION_KEY);
    return isCompareOrientation(value) ? value : DEFAULT_ORIENTATION;
  } catch {
    return DEFAULT_ORIENTATION;
  }
};

export const writeCompareOrientation = (value: CompareOrientation): void => {
  try {
    localStorage.setItem(COMPARE_ORIENTATION_KEY, value);
  } catch {
    // Browser storage can be unavailable; the current selection still works.
  }
};
